import {SelectOption} from './_interfaces';

export const AllSelectOption: SelectOption = {val: 'all', label: 'Tutti'};
